const methods = {
	get: "GET",
	post: "POST",
	put: "PUT",
	delete: "DELETE"
}

const contentType = {
	json: "application/json",
	formData: "multipart/form-data"
}
const resultType = {
	success: "SUCCESS",
	failed: "FAILED"
}
export {
	methods,resultType,contentType
}